import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import { t } from 'ttag';

import Favicon16 from '@static/img/meta/favicon-16x16-min.png';
import Favicon32 from '@static/img/meta/favicon-32x32-min.png';
import Favicon96 from '@static/img/meta/favicon-96x96-min.png';
import AndroidChrome192 from '@static/img/meta/android-chrome-192x192-min.png';
import AppleIcon57 from '@static/img/meta/apple-touch-icon-57x57.png';
import AppleIcon60 from '@static/img/meta/apple-touch-icon-60x60.png';
import AppleIcon72 from '@static/img/meta/apple-touch-icon-72x72.png';
import AppleIcon76 from '@static/img/meta/apple-touch-icon-76x76.png';
import AppleIcon114 from '@static/img/meta/apple-touch-icon-114x114.png';
import AppleIcon120 from '@static/img/meta/apple-touch-icon-120x120.png';
import AppleIcon144 from '@static/img/meta/apple-touch-icon-144x144.png';
import AppleIcon152 from '@static/img/meta/apple-touch-icon-152x152.png';
import AppleIcon180 from '@static/img/meta/apple-touch-icon-180x180.png';
import ShafaOGImage from '@static/img/meta/shafa-og-image-new-min.png';
import MsTile144 from '@static/img/meta/mstile-144x144.png';
import { getShafaAbsoluteUrl, hasAdvertisementParameter } from '@utils/common';
import { mainPage } from '@legacyUrls';
import { PageMetaDescription } from '@components/PageMetaDescription';

type BaseLayoutProps = React.HTMLProps<HTMLDivElement>;

export const BaseLayout: React.FC<BaseLayoutProps> = (props) => {
  const history = useHistory();
  const { location } = history;

  const currentAbsoluteUrl = history.createHref(location);
  return (
    <>
      <Helmet
        titleTemplate="%s | Шафа"
        defaultTitle="Шафа"
      >
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Check with seo */}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={getShafaAbsoluteUrl(`/uk${location.pathname}${location.hash}${location.search}`)}
        />
        <link
          rel="alternate"
          hrefLang="uk"
          href={getShafaAbsoluteUrl(`/uk${location.pathname}${location.hash}${location.search}`)}
        />
        <link
          rel="alternate"
          hrefLang="ru"
          href={getShafaAbsoluteUrl(`${location.pathname}${location.hash}${location.search}`)}
        />

        {/* Image for different social medias */}
        <link rel="image_src" href={ShafaOGImage} />

        {/* Meta for Facebook Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentAbsoluteUrl} />
        <meta property="og:image" content={ShafaOGImage} />

        {/* Meta for Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:image" content={ShafaOGImage} />

        {/* Icon for Apple */}
        <link rel="apple-touch-icon" sizes="57x57" href={AppleIcon57} />
        <link rel="apple-touch-icon" sizes="60x60" href={AppleIcon60} />
        <link rel="apple-touch-icon" sizes="72x72" href={AppleIcon72} />
        <link rel="apple-touch-icon" sizes="76x76" href={AppleIcon76} />
        <link rel="apple-touch-icon" sizes="114x114" href={AppleIcon114} />
        <link rel="apple-touch-icon" sizes="120x120" href={AppleIcon120} />
        <link rel="apple-touch-icon" sizes="144x144" href={AppleIcon144} />
        <link rel="apple-touch-icon" sizes="152x152" href={AppleIcon152} />
        <link rel="apple-touch-icon" sizes="180x180" href={AppleIcon180} />

        {/* Icon */}
        <link rel="icon" type="image/png" href={Favicon16} sizes="16x16" />
        <link rel="icon" type="image/png" href={Favicon32} sizes="32x32" />
        <link rel="icon" type="image/png" href={Favicon96} sizes="96x96" />
        <link rel="icon" type="image/png" href={AndroidChrome192} sizes="192x192" />

        {/* Theme color */}
        <meta name="msapplication-TileColor" content="#000000" />
        <meta name="msapplication-TileImage" content={MsTile144} />
        <meta name="theme-color" content="#eeeeee" />
        <meta name="apple-mobile-web-app-status-bar-style" content="#8FDBB0" />

        {/* DNS-Prefetch */}
        <meta name="p:domain_verify" content="2befc6ff4a9e8cc4994d706aa182b1cc" />
        <link rel="dns-prefetch" href="//assets.shafastatic.net" />
        <link rel="dns-prefetch" href="//avatars.shafastatic.net" />
        <link rel="dns-prefetch" href="//image-thumbnails.shafastatic.net" />
        <link rel="dns-prefetch" href="//image-thumbnails.shafastatic.net" crossOrigin='anonymous' />

        {/* Canonical link without route search part */}
        {
        (hasAdvertisementParameter(location.search) || location.pathname === mainPage) && (
          <link
            rel="canonical"
            href={getShafaAbsoluteUrl(history.createHref({ pathname: location.pathname }))}
          />
        )
      }
      </Helmet>

      <PageMetaDescription
        description={t`Шафа - це сайт для продажу та обміну жіночого одягу. Розпродайте свій гардероб та знайдіть щось цікаве для себе!`}
      />
      {/* Email for Esputnik */}
      {/* TODO(a.kravchuk) */}
      <div {...props} />
    </>
  );
};
